import { CommonModule, NgOptimizedImage } from '@angular/common';
import { Component, Input } from '@angular/core';
import { DynamicModule } from 'ng-dynamic-component';
import { StoryblokDirective } from 'src/app/directive/storyblok.directive';

@Component({
  selector: 'app-call-out',
  imports: [CommonModule, NgOptimizedImage, StoryblokDirective, DynamicModule],
  templateUrl: './call-out.component.html',
  styleUrl: './call-out.component.scss',
})
export class CallOutComponent {
  @Input() _uid: string = '';
  @Input() image: { filename: string } = { filename: '' };
  @Input() blocks: any[] = [];
  @Input() component: string = '';
  @Input() _editable: string = '';
  @Input() position: string = 'top left';
  @Input() colour: string = '#FFCB67';

  components: any;

  constructor() {
    import('src/app/storyblok/components').then((cp) => {
      this.components = cp.Components;
    });
  }
}
